module.exports = __webpack_public_path__ + "static/img/IMG_8309.58c9fd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fotosGaleriaSicarf/IMG_8309.jpg
// module id = DXqE
// module chunks = 11